module.exports = __webpack_public_path__ + "img/MELA_Myofibroblasts.e0311a4f.png";